import { render, staticRenderFns } from "./ReenviarDocumento.vue?vue&type=template&id=19f1202d"
import script from "./ReenviarDocumento.vue?vue&type=script&lang=js"
export * from "./ReenviarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports